import styled from 'styled-components';
import { Accordion } from 'react-accessible-accordion';
import variables from '../../../styles/variables';

export const Container = styled.div`
  display: block;
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;
  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
  @media screen and (max-width: 768px) {
    justify-content: space-between;
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const SectionHeading = styled.p`
  font-size: 11px;
  line-height: 11px;
  font-weight: normal;
  letter-spacing: 0.458px;
  margin-bottom: 12px;

  &.pricing {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;

export const GalleryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  order: 1;
  justify-content: center;
  float: left;
  clear: right;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 60%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    float: none;
    clear: none;
  }
  @media screen and (max-width: 414px) {
    height: 400px;
  }
`;

export const DeviceInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  order: 2;
  padding: 45px 0 30px 45px;
  float: right;
  clear: right;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 40%;
    padding: 30px ${variables.mobileLayoutPadding}rem;
  }
  @media screen and (max-width: 768px) {
    margin-top: 30px;
    width: 100%;
    padding: 0;
    float: none;
    clear: none;
  }
`;

export const SpecsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  order: 3;
  float: left;
  clear: left;
  padding-right: 60px;
  @media screen and (max-width: 1024px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 60%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    float: none;
    clear: none;
    padding-right: ${variables.mobileLayoutPadding}rem;
  }
`;

export const PhoneTitle = styled.h1`
  margin-bottom: 24px;
  width: 100%;
  text-transform: none;
  line-height: normal;
  span.brand {
    font-size: 16px;
    line-height: 16px;
    font-weight: normal;
    margin-bottom: -10px;
    display: block;
    @media screen and (max-width: 415px) {
      margin-bottom: -14px;
      font-size: 14px;
      line-height: 14px;
      &::after {
        content: ' ';
      }
    }
  }
  span.model {
    font-size: 28px;
    line-height: 28px;
    font-weight: 600;
    @media screen and (max-width: 415px) {
      font-size: 20px;
      line-height: 20px;
    }
  }
`;

export const ColourPickerContainer = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const MemoryContainer = styled.div`
  width: 100%;
  margin-bottom: 47px;
  @media screen and (max-width: 415px) {
    margin-bottom: 24px;
  }
`;

export const PricingContainer = styled.div`
  width: 100%;
`;

export const CarrierPricingWrapper = styled(Accordion)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CarrierPricingDetailsWrapper = styled(Accordion)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LegalNote = styled.p`
  font-size: 10px;
  line-height: normal;
  margin: 0;
`;

export const LegalNoteSection = styled.div`
  margin-bottom: 30px;
`;

export const CompareWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

export const ComparePhoneButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 200px;
  height: 53px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border: none;
  background: ${variables.colorWhite};
  color: ${(props) => (props.disabled ? '#9C9C9C' : '#333333')};
  border-radius: 26px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin: 5px;
`;

export const GetPhoneButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 200px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin: 5px;
  text-align: center;
  text-decoration: none;
  padding: 18px 10px;
`;

export const ReservePhoneButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 200px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin: 5px;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
  }
  transition:
    background-color 0.3s,
    color 0.3s;
`;

export const PreorderPhoneButton = styled.a`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 200px;
  height: 53px;
  padding: 1rem;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin: 5px;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
  }
  transition:
    background-color 0.3s,
    color 0.3s;
`;

export const AdditionalInfo = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${variables.colorBlack};
  padding-top: 50px;
  margin-top: 50px;
  margin-bottom: 0;
  border-top: 1px ${variables.colorGreyMedium} solid;
  @media screen and (max-width: 767px) {
    padding-bottom: 30px;
  }
`;

export const LoadingWrapper = styled.div`
  margin: 40px 0;
  width: 100%;
  height: 300px;

  @media screen and (max-width: 768px) {
    height: auto;
  }
`;

export const DeviceTypeWrapper = styled.p`
  font-size: 1rem;
  line-height: 1.25rem;
  color: ${variables.colorWhite};
  border-radius: 0.5rem;
  background: ${variables.colorBlack};
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
  @media screen and (max-width: 767px) {
    margin-bottom: 0;
  }
`;

export const DevicePromoWrapper = styled.p`
  font-size: 11px;
  line-height: 11px;
  font-weight: 500;
  text-transform: uppercase;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 0.25em;
  padding: 0.25em 0.5em;
  margin-bottom: 0.5rem;
  @media screen and (max-width: 767px) {
    margin-bottom: 0;
  }
`;

export const CtaWrapper = styled.p`
  display: flex;
`;
